let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("RUaGU")).then(() => parcelRequire('2To7f'));